<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">{{lang.LBL_MODULE_TITLE}}</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/institutionaldocs/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction" :filtersearch="filter"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/InstitutionalDocs/MenuList.vue";
    import lang from "@/views/modules/InstitutionalDocs/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomSearch from "@/views/modules/InstitutionalDocs/SearchView.vue";

    export default {
        name: "new-ed-requets",
        components: {
            breadcrumbs,
            GenericList,
            CustomSearch,
        },
        data() {
            return {
                generic:true,
                isActive: false,
                filter: false,
                lang:[],
                metaList: [
                  
                    {
                        label: lang.LBL_DOCUMENT_SEQUENCE,
                        link: true,
                        moduleName: 'InstitutionalDocs',
                        routePath: 'institutionaldocs',
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'document_sequence'
                    
                    },
                    {
                        label: lang.LBL_DOCUMENT_TITLE,
                        link: true,
                        moduleName: 'InstitutionalDocs',
                        routePath: 'institutionaldocs',
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'document_title'
                    
                    },
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'description'
                    },
                    {
                        label: lang.LBL_REQUEST_STATUS,
                        link: false,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'status'
                    },
                    {
                        label: lang.LBL_UPLOAD_BY,
                        link: false,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'created_by'
                    
                    },
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        link: false,
                         moduleName: 'InstitutionalDocs',
                        routePath: 'institutionaldocs',
                        is_download:true,
                        linkOtherModule:false,
                        isSort: true,
                        field_name: 'doc_path'
                    },
                ],
                columns: ['document_sequence', 'document_title', 'description', 'status', 'created_by', 'doc_path'],
            }
        },
        mounted() {
            this.lang = lang;
            this.childMethod();
            this.$emit('MetaView', 'Awesome');
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getProducts(search);
                    }
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>